import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'types';
import { initialState } from '.';

const selectSlice = (state: RootState) => state.metadata || initialState;

export const selectMetadata = createSelector(
  [selectSlice],
  state => state.data,
);

export const selectValveTypeMetadata = createSelector(
  [selectSlice, (state, basicForm) => basicForm],
  (metadata, basicForm) => metadata.data[basicForm],
);

export const selectMetadataMandatoryAttr = createSelector(
  [selectSlice, (state, basicFormObject) => basicFormObject],
  (metadata, basicFormObject) => {
    let { basicForm, actuatorType, valveType, currentStep, isNonDirectMount } =
      basicFormObject;
    let metadataItem;
    if (isNonDirectMount && currentStep === 2 && actuatorType !== 'gearbox') {
      metadataItem = metadata.data[valveType].find(
        item => item.basicForm === actuatorType,
      );
      return metadataItem.mandatoryAttributes[`non_direct_${basicForm}`];
    }
    if (currentStep === 3) {
      metadataItem = metadata.data[valveType].find(
        item => item.basicForm === 'monitoring',
      );
    } else {
      metadataItem = metadata.data[valveType].find(
        item => item.basicForm === basicForm,
      );
    }
    if (
      currentStep === 3 &&
      actuatorType === 'gearbox' &&
      basicForm !== 'dual_sensor'
    ) {
      basicForm = `gearbox_${basicForm}`;
    }
    return metadataItem && metadataItem.mandatoryAttributes
      ? metadataItem.mandatoryAttributes[basicForm.toLowerCase()] || []
      : [];
  },
);

export const selectMetadataFilterAttr = createSelector(
  [selectSlice, (state, basicFormObject) => basicFormObject],
  (metadata, basicFormObject) => {
    const { basicForm, valveType } = basicFormObject;
    const metadataItem = metadata.data[valveType].find(
      item => item.basicForm === basicForm,
    );
    return metadataItem?.filterAttributes || [];
  },
);

export const selectMetadataProdTimeAttr = createSelector(
  [selectSlice, (state, basicFormObject) => basicFormObject],
  (metadata, basicFormObject) => {
    const { basicForm, valveType } = basicFormObject;
    const metadataItem = metadata.data[valveType].find(
      item => item.basicForm === basicForm,
    );
    return metadataItem?.productionTimeAttributes || [];
  },
);
